export const screenSize = {
 mobile: 414,
 tablet: 768,
 laptop: 1024,
 hdReady: 1280,
 hd: 1440,
 fullHd: 1850
}
